import { render, staticRenderFns } from "./IviewCheckboxGroup.vue?vue&type=template&id=50717ca7&scoped=true&"
import script from "./IviewCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./IviewCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./IviewCheckboxGroup.vue?vue&type=style&index=0&id=50717ca7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50717ca7",
  null
  
)

export default component.exports